export default __webpack_public_path__ + "static/media/submitIcon.c3f892db.png";